/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgLoopIcon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 2A10 10 0 0 0 2 12v10h10a10 10 0 0 0 0-20Zm0 6.5a3.5 3.5 0 1 1 0 7H8.5V12A3.5 3.5 0 0 1 12 8.5Z",
        fill: "url(#LoopIcon_svg__a)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22 12a10 10 0 0 1-10 10H2a6.5 6.5 0 0 1 6.5-6.5H12a3.5 3.5 0 0 0 3.5-3.5H22Z",
        fill: "url(#LoopIcon_svg__b)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22 12a10 10 0 0 1-10 10H2a6.5 6.5 0 0 1 6.5-6.5H12a3.5 3.5 0 0 0 3.5-3.5H22Z",
        fill: "url(#LoopIcon_svg__c)",
        fillOpacity: 0.56
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22 12a10 10 0 0 1-10 10H2a6.5 6.5 0 0 1 6.5-6.5H12a3.5 3.5 0 0 0 3.5-3.5H22Z",
        fill: "url(#LoopIcon_svg__d)",
        fillOpacity: 0.15
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12 2A10 10 0 0 0 2 12v10a6.5 6.5 0 0 0 6.5-6.48l.02-.02H8.5V12a3.5 3.5 0 0 1 6-2.46l4.6-4.58A9.97 9.97 0 0 0 12 2Z",
        fill: "url(#LoopIcon_svg__e)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12 2A10 10 0 0 0 2 12v10a6.5 6.5 0 0 0 6.5-6.48l.02-.02H8.5V12a3.5 3.5 0 0 1 6-2.46l4.6-4.58A9.97 9.97 0 0 0 12 2Z",
        fill: "url(#LoopIcon_svg__f)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "LoopIcon_svg__c",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(4 2.75 -4.83318 7.0301 5.5 17.75)"
    }, /*#__PURE__*/ React.createElement("stop", null), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "LoopIcon_svg__d",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(7.4 4.6 -8.08463 13.0057 4.3 17)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.33
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "LoopIcon_svg__f",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(13.40004 -2.3 6.04701 35.2304 .3 8.2)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6D05E8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#6D05E8",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "LoopIcon_svg__a",
        x1: 14.2,
        y1: 9.1,
        x2: 10.9,
        y2: 22.6,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9237E3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#48E6F3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "LoopIcon_svg__b",
        x1: 8.5,
        y1: 20.5,
        x2: 17.3,
        y2: 18.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#51E6FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#71D4FF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "LoopIcon_svg__e",
        x1: 6.1,
        y1: 12.7,
        x2: 11.2,
        y2: 5.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6E06E9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#AB5ADD",
        stopOpacity: 0
    }))));
export default SvgLoopIcon;
